<form *ngIf="conf.Groups.length > 0" #dynamicForm="ngForm" [ngClass]="{ readonly: ReadOnly == true }">
    <div class="mb-1 row" *ngFor="let group of conf.Groups; let idx=index">
      <div class=" col-8 labelHead">
        {{ group.GroupDescription }} 
        <span class="icons-box" >
         <span class="ml-5" *ngIf="(!group?.fieldsReadOnly || (group?.GroupName == 'PhoneNumbers' && group.viewMode)) && !getIsReadOnlyCase()" (click)="editGroupFields(group)"
         >Edit
           <img
            alt="edit"
            src="{{ baseHref }}/assets/images/icon-pen-edit.png"
            class=""
          />
         </span>
          <span class="ml-5 save-action" *ngIf="!group.viewMode" 
          [class.disabled]="group.isSave"
            [attr.aria-disabled]="group.isSave ? 'true' : 'false'" 
            (click)="group.isSave ? null : editGroupFields(group)"
          > Save 
            <img
            alt="save"
            src="{{ baseHref }}/assets/images/icon-tick-save.png"
            class=""
          />
          </span>
        </span>
        <button
          class="btn btn-secondary add-field-btn"
          [ngClass]="group.viewMode ? 'read-only' : ''"
          *ngIf="group.IsMultiple && group.multipleOptions.options.length > 0"
          (click)="openModal(group)" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
        >
          + Add
        </button>
        <!-- <button class="btn btn-secondary add-field-btn" *ngIf="group.IsMultiple && !group.multipleOptions.options.length==0" (click)="addNewFieldGroup(group)">
        + Add
      </button> -->

      <!-- Button trigger modal -->
<!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch demo modal
</button> -->

<!-- Modal -->
<!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div> -->
        <!-- <div [ngStyle]="{ display: display }"> -->
          <!-- <div class="modal" [ngStyle]="{ display: display }"> -->
            <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content" style="width: 290px; left:6rem">
                <div class="modal-header menu" style="border-radius: 0">
                  <span class="menu-heading"> Choose a {{ modalGroupObj?.GroupDescription }} type:</span>
                  <span class="close" data-bs-dismiss="modal" (click)="onCloseHandled(modalGroupObj)">X</span>
                </div>
                <div class="modal-body">
                  <div
                    class="form-check mb-2"
                    *ngFor="let opt of modalGroupObj?.multipleOptions.options; let i = index"
                    (change)="onMultipleOptionChange(opt, modalGroupObj)"
                  >
                    <input
                      class="form-check-input checkbox"
                      style="border: 0.125rem solid #2f78c4; border-radius: 0.125rem"
                      type="checkbox"
                      value=" "
                      [checked]="opt.Selected"
                      id="defaultCheck-{{ i }}"
                    />
                    <label
                      class="form-check-label checkbox-label"
                      for="defaultCheck-{{ i }}"
                      style="
                        text-align: left;
                        font: normal normal medium 0.938rem/1.125rem Gellix;
                        font-weight: medium;
                        font-size: 0.938rem;
                        line-height: 1.125rem;
                        letter-spacing: 0rem;
                        color: #000048;
                        opacity: 1;
                      "
                    >
                      {{ opt.name }} <span class="star" *ngIf="field.isRequired"> *</span>
                    </label>
                  </div>
                  <hr class="hrPopUpRow" />
                  <div style="justify-content: center;display: flex;margin: 17px 0 -4px 0px;"> 
                    <button type="button" [ngClass]="'done-btn-active'" data-bs-dismiss="modal" (click)="onAddMultipleOption(modalGroupObj)">
                      Done
                    </button>
                  </div>
                  
                </div>
                <!-- <div class="modal-footer" style="justify-content: center">
                  
                </div> -->
              </div>
            </div>
            </div>
          <!-- </div> -->
        <!-- </div> -->

        <!-- <span (click)="editForm()" *ngIf="group.GroupDescription === 'Basic Information'">
        <img alt src="{{ baseHref }}/assets/images/icon-eye.svg" class="floatRight" />
      </span> -->
     
      </div>
      <div style="float: right;" class="col-4 btn-div">
        <!-- <span style="margin-right: 0.6rem;">
          <button *ngIf="false && showChangeUser" class="change-user" (click)="changeUser()">Change User</button>
        </span> -->
      </div>
      <hr class="hrRow" />
    <div class="chnguser-div" *ngIf="idx==0">
      <button *ngIf="showChangeUser" class="change-user" (click)="changeUser()">Change User</button>
    </div>
      <!--
    Field Types:
    ShortText
    TextArea*
    CheckBox*
    RadioButton*
    DropDown*
    Input*
    Hidden
    CheckBoxGroup
    CheckBoxGroupWithOther
    Password*
    MultiSelect*
    DatePicker*
    DateTimePicker*
    ChilkablePhoneNumber
    UserPicker
    CaseUserPicker
    FIlePicker
    CaseAssigner
  -->
      <div class="row">
        <ng-container *ngFor="let field of group.Fields">
          <ng-container *ngIf="field.fieldType === 'Input' && field.show">
            <div class="col-6 form-row input-data">
              <label for="{{ field.Name }}"
                >{{ field.Label }}
                <span class="star" *ngIf="field.isRequired" [hidden]="field.viewMode"> *</span></label
              >
              <input
                [id]="field.fieldID"
                [name]="field.Name"
                [value]="getModel(group, field)"
                [required]="field.isRequired"
                [ngClass]="{ 'readonly': field.viewMode? field.viewMode : false  || (field.isFromAPI? field.isFromAPI : false)}"
                [pattern]="field.pattern"
                [attr.maxlength]="field.maxLength"
                [attr.minlength]="field.minLength"
                [disabled]="field.isDisabled"
                [attr.type]="field.isEmail ? 'email' : 'text'"
                (input)="onFormDataChange(group, field, $event,null)"
                [readonly] = "field.viewMode? field.viewMode : false || (field.isFromAPI? field.isFromAPI : false)"
              />
              <!-- group.viewMode ? 'read-only' : '' || -->
              <span *ngIf="group.IsMultiple" class="remove" title="Delete"   [ngClass]=" field.isFromAPI ? 'd-none':'' "  (click)="deleteField(group, field)">X</span>
              <div class="underline-fixed" [hidden]="field.viewMode" ></div>

              <div class="text-danger" *ngIf="field.invalid">
                <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                <small *ngIf="field.minlengthError">
                  {{ field.Label }} must be at least {{ field.minLength }} characters</small
                >
                <small *ngIf="field.maxlengthError">
                  {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                >
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="field.fieldType === 'Password' && field.show">
            <div class="col-6 form-row input-data">
              <label for="{{ field.Name }}"
                >{{ field.Label }}
                <span class="star" *ngIf="field.isRequired" [hidden]="field.viewMode"> *</span></label
              >
              <input
                type="password"
                [id]="field.fieldID"
                [name]="field.Name"
                [disabled]="field.isDisabled"
                [value]="getModel(group, field)"
                [required]="field.isRequired"
                [ngClass]="field.viewMode ? 'read-only' : ''"
                [pattern]="field.pattern"
                [attr.maxlength]="field.maxLength"
                [attr.minlength]="field.minLength"
                (input)="onFormDataChange(group, field, $event,null)"
              />
              <div class="underline-fixed" [hidden]="field.viewMode"></div>

              <div class="text-danger" *ngIf="field.invalid">
                <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                <small *ngIf="field.minlengthError">
                  {{ field.Label }} must be at least {{ field.minLength }} characters</small
                >
                <small *ngIf="field.maxlengthError">
                  {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                >
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="field.fieldType === 'DropDown' && field.show">
            <div class="col-6 form-row input-data">
              <label for="{{ field.Name }}"
                >{{ field.Label }}
                <span class="star" *ngIf="field.isRequired" [hidden]="field.viewMode"> *</span></label
              >
              <select
                [ngModel]="getModel(group, field)"
                [name]="field.Name"
                [disabled]="field.isDisabled"
                [id]="field.fieldID"
                [required]="field.isRequired"
                [ngClass]="field.viewMode ? 'read-only' : ''"
                (change)="onDropDownChange(group, field, $event)"
              >
                <option value="">Select One</option>
                <option *ngFor="let option of field.fieldOptions | orderBy: 'DisplayOrder'" value="{{ option.Value }}">
                  {{ option.Name }}
                </option>
              </select>
              <div class="underline-fixed" [hidden]="field.viewMode"></div>
              <div class="text-danger" *ngIf="field.invalid">
                <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                <small *ngIf="field.minLengthError">
                  {{ field.Label }} must be at least {{ field.minLength }} characters
                </small>
                <small *ngIf="field.maxLengthError">
                  {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                >
              </div>
            </div>
          </ng-container>
     
          <ng-container
          *ngIf="(field.fieldType === 'DateTimePicker') && field.show" style="width: 10rem">
          <div class="col-6 mb-5p input-data">
            <label for="{{ field.Name }}"
              >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label
            >
            <div style="margin: 8px 0px 2px 0px;"> 
 <!-- Custom Datepicker With Timezone -->
 <app-calendar-with-timezone
 [defaultDate]="field.value"
 [showTime] = "true"
 [hourFormat]= "12"
 [disabled]="field.isDisabled"
 [displayTimeZone] = "false"
 [parentWidth] = "'320px'"
 (dateSelected)="onCalendarDateSelected(group, field, $event)"
></app-calendar-with-timezone>  
            </div>
           
            
            <div class="underline-fixed" [hidden]="field.viewMode"></div>
            <div class="text-danger" *ngIf="field.invalid">
              <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
              <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
              <small *ngIf="field.minLengthError">
                {{ field.Label }} must be at least {{ field.minLength }} characters
              </small>
              <small *ngIf="field.maxLengthError">
                {{ field.Label }} must be at most {{ field.maxLength }} characters</small
              >
            </div>
          </div>
        </ng-container>
          <ng-container
            *ngIf="(field.fieldType === 'DatePicker') && field.show"
            style="width: 10rem"
          >
            <div class="col-6 form-row input-data">
              <label for="{{ field.Name }}"
                >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label
              >
              <input
                type="date"
                name="followUp"
                class="datetimepicker"
                [ngModel]="field.value | date: 'yyyy-MM-dd'"
                (ngModelChange)="field.value = $event"
                (change)="onFormDataChange(group, field, $event,null)"
                [value]="getModel(group, field)"
                [ngModelOptions]="{ standalone: true }"
                autocomplete="off"
                [disabled]="field.isDisabled"
                [ngClass]="field.viewMode ? 'read-only' : ''"
              />

              <div class="underline-fixed" [hidden]="field.viewMode"></div>
              <div class="text-danger" *ngIf="field.invalid">
                <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                <small *ngIf="field.minLengthError">
                  {{ field.Label }} must be at least {{ field.minLength }} characters
                </small>
                <small *ngIf="field.maxLengthError">
                  {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                >
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="field.fieldType === 'Hidden'">
            <input
              class="hidden"
              type="hidden"
              [id]="field.fieldID"
              [name]="field.Name"
              [value]="getModel(group, field)"
            />
          </ng-container>
          <ng-container *ngIf="field.fieldType === 'CheckBox' && !field.isEmail  && field.show">
            <div class="col-12 mb-5p">
              <div class="form-check">
                <input
                  class="form-check-input checkbox"
                  type="checkbox"
                  [value]="getModel(group, field)"
                  [disabled]="field.isDisabled"
                  (change)="onCheckBoxChange(group, field, $event)"
                  [checked]="field.isSelected"
                  [id]="field.fieldID"
                  [ngClass]="field.viewMode ? 'read-only' : ''"
                />
                <label class="checkbox-label form-check-label-1" for="{{ field.fieldID }}">
                  {{ field.Label }}
                </label>
              </div>
              <!-- <div class="underline-fixed"></div> -->
              <div class="text-danger" *ngIf="field.invalid">
                <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                <small *ngIf="field.minLengthError">
                  {{ field.Label }} must be at least {{ field.minLength }} characters
                </small>
                <small *ngIf="field.maxLengthError">
                  {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                >
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="field.fieldType === 'TextArea' && !field.isEmail && field.show">
            <div
              class="col-12 input-data"         
            >
              <div style="margin-top: 5px">
                <label for="{{ field.Name }}"
                  >{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span>
                 </label
                >

                <textarea
                  class="form-control"
                  id="{{ field.fieldID }}"
                  [value]="getModel(group, field)"
                  (input)="onFormDataChange(group, field, $event,null)"
                  placeholder=""
                  [disabled]="field.isDisabled"
                  [ngClass]="{ 'readonly': field.viewMode? field.viewMode : false }"
                  [readonly] = "field.viewMode? field.viewMode : false"
                ></textarea>


                <div class="text-danger" *ngIf="field.invalid">
                  <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
                  <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
                  <small *ngIf="field.minLengthError">
                    {{ field.Label }} must be at least {{ field.minLength }} characters
                  </small>
                  <small *ngIf="field.maxLengthError">
                    {{ field.Label }} must be at most {{ field.maxLength }} characters</small
                  >
                </div>
              </div>

            
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </form>

  
